import type { ServiceImage } from "@warrenio/api-spec/spec.oats.gen";

export const serviceImagesList: ServiceImage[] = [
    {
        created_at: "2021-11-03 12:30:26",
        description: "Fully managed PostgreSQL database so you can focus on your code.",
        display_name: "PostgreSQL",
        icon: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjQuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA5MiA5MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgOTIgOTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMzM2NzkxO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS13aWR0aDozO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik03MSwzMWMwLjItMS4yLDAuMy0yLjMsMC40LTMuNWMtNS0wLjctNywwLjUtNy44LDEuNkM2MSwzMi44LDY2LDQxLjgsNjguMiw0NS42YzAuNSwxLDAuOSwxLjcsMS4xLDIuMQoJYzAuMiwwLjYsMC41LDEuMSwwLjgsMS42YzEuNi0zLjIsMS4yLTYuNSwwLjgtOS42Yy0wLjItMS41LTAuNC0zLjEtMC4zLTQuNkM3MC42LDMzLjUsNzAuOCwzMi4zLDcxLDMxeiBNNjguNiwzMC4yCgljLTAuMiwwLjItMC43LDAuNy0xLjQsMC44Yy0wLjIsMC0wLjMsMC0wLjMsMGMtMSwwLTEuOS0wLjgtMS45LTEuM2MtMC4xLTAuNiwwLjktMS4xLDEuOS0xLjJzMi4xLDAsMi4yLDAuNgoJQzY5LjEsMjkuNCw2OC45LDI5LjgsNjguNiwzMC4yeiBNNjcuNiwxNC43YzMuNiw0LjMsNS42LDguOSw1LjksMTAuOWMwLjIsMC4yLDAuNCwwLjUsMC40LDAuOGMwLjEsMS45LTAuMSwzLjUtMC40LDUKCWMtMC4yLDEuMi0wLjQsMi40LTAuNCwzLjhjMCwxLjMsMC4xLDIuNywwLjMsNC4yYzAuNSwzLjcsMSw3LjktMS43LDEyLjFjMC4xLDAuMiwwLjMsMC4zLDAuNCwwLjRjOS44LTE1LjQsMTMuMi0zMy4zLDEwLjItMzcuMgoJYy00LTUuMS05LjYtNy44LTE2LjgtNy45Yy0zLTAuMS01LjYsMC4yLTcuNSwwLjZDNjIuMyw5LjQsNjUuNSwxMi4yLDY3LjYsMTQuN3ogTTcwLjUsNTMuOWMtMC4yLTAuMy0wLjQtMC41LTAuNy0wLjkKCWMtMC44LTEtMS45LTIuMy0yLjctNC40Yy0wLjEtMC4zLTAuNS0xLTEtMS45Yy0yLjYtNC42LTcuOS0xNC4yLTQuNS0xOS4xYzEuNi0yLjMsNC43LTMuMiw5LjMtMi43Yy0wLjYtMS44LTIuMS01LjItNS04LjUKCWMtMy4zLTMuOS05LjEtOC41LTE4LjItOC43Yy0zLjUtMC4xLTYuNiwwLjctOS4xLDIuNWMtMC4yLDAuMy0wLjQsMC40LTAuNywwLjVjLTAuNSwwLjQtMC45LDAuOC0xLjQsMS4yYy00LjcsNC43LTUuOCwxMi4xLTYsMTUuOQoJYzAuMy0wLjIsMC42LTAuMywwLjktMC41YzEuMS0wLjYsMy40LTEuNiw1LjktMS44YzQuMi0wLjQsNi45LDEuNCw3LjgsNS4yYzIuMiwxMC4yLDAuMiwxNC43LTEuMywxOGMtMC4zLDAuNi0wLjUsMS4yLTAuNywxLjcKCWwtMC4yLDAuNWMtMC40LDEuMS0wLjgsMi4yLTEsMy4xYzEtMC4yLDEuOCwwLjEsMi4zLDAuM2MxLjIsMC41LDIuMywxLjgsMi43LDMuMmMwLjEsMC40LDAuMiwwLjcsMC4yLDEuMWMwLDAsMCwwLjEsMCwwLjEKCWMtMC4xLDMtMC4xLDUuOS0wLjEsOC42YzAuMSwxLjEsMC4xLDIuMywwLjEsMy40YzAsMC4yLDAsMC4zLDAsMC41YzAuMSw0LjUsMC41LDcuOSwwLjksOWMxLjMsMy4yLDMuMiw2LDguNyw0LjgKCWM1LjMtMS4xLDcuMS0zLDgtOC4xYzAuNy0zLjcsMS45LTEzLjgsMi4yLTE2LjdjMC0wLjEsMC0wLjItMC4xLTAuMkM2Ni41LDU1LjMsNjkuMSw1NC4zLDcwLjUsNTMuOXogTTcyLjMsNTYuMgoJYy0wLjEtMC4xLTAuMi0wLjItMC4zLTAuM2MtMC4yLDAuMS0wLjMsMC4xLTAuNSwwLjJjLTEuMiwwLjQtMi4zLDAuNy0yLjEsMy42YzAuMywwLjIsMS42LDAuNiw0LjEsMC41YzIuMy0wLjEsNC42LTAuNiw2LjEtMS4zCgljMS43LTAuOCwyLjgtMS42LDMuNS0yLjNjMCwwLDAsMC0wLjEsMEM3Ny45LDU3LjYsNzQuNCw1Ny41LDcyLjMsNTYuMnogTTMzLDUwLjZjMS43LDEuOCw0LDIuOCw2LjMsMi44YzAuMy0xLjEsMC43LTIuMiwxLjItMy41CglsMC4yLTAuNWMwLjItMC42LDAuNS0xLjIsMC44LTEuOWMxLjQtMy4xLDMuMi03LjEsMS4xLTE2LjVjLTAuNC0xLjgtMS4zLTIuOS0yLjktMy4yYy0zLjMtMC43LTguMSwxLjgtOS4xLDIuN3YwLjgKCWMwLjEsMi4xLDAuNCw2LjEtMC4zLDEwLjZDMjkuOCw0NS4xLDMwLjgsNDguMywzMyw1MC42eiBNMzcuMiwyOS40YzAuNC0wLjMsMS4yLTAuNCwyLjEtMC4zYzEuMSwwLjIsMi4yLDAuNywyLjEsMS41CgljMCwwLjYtMSwxLjQtMiwxLjRoLTAuM2MtMC43LTAuMS0xLjMtMC41LTEuOC0xLjFjLTAuMi0wLjItMC40LTAuNi0wLjQtMUMzNi45LDI5LjgsMzcsMjkuNiwzNy4yLDI5LjR6IE00My4zLDU2LjYKCWMtMC43LTAuMy0xLTAuNC0xLjgsMC41Yy0wLjUsMC42LTAuOSwxLjEtMS4zLDEuNWMtMS41LDEuOS0yLjIsMi42LTYuNywzLjVjLTAuOSwwLjEtMS40LDAuMy0xLjcsMC41YzAuNCwwLjIsMSwwLjUsMS42LDAuNwoJYzMuMywwLjgsNy45LDAuOSwxMS0zLjVjMC40LTAuNSwwLjMtMS4yLDAuMi0xLjVDNDQuNCw1Ny42LDQzLjksNTYuOSw0My4zLDU2LjZ6IE0zMS4zLDUyLjRjLTIuNy0yLjgtMy45LTYuNy0zLjQtMTAuNwoJYzAuNi00LjMsMC40LTguMSwwLjMtMTAuMWMwLTAuMywwLTAuNi0wLjEtMC44Yy0wLjEtMC4yLTAuMi0wLjQtMC4yLTAuNmMwLTAuNS0wLjMtMTIuOCw2LjgtMjBjMC4xLTAuMSwwLjItMC4yLDAuMy0wLjMKCUMzMC41LDguNSwyMC4yLDYsMTMuOCwxMC41Yy00LDIuOC01LjgsOC4xLTUuNCwxNS42QzguNSwyOC41LDEwLDM3LDEyLjYsNDUuNWMzLDkuOCw2LjQsMTYsOS4zLDE2LjljMC40LDAuMSwxLjgsMC42LDMuOC0xLjgKCWMyLjctMy4zLDUuMy02LDYuNS03LjRDMzEuOSw1MywzMS42LDUyLjcsMzEuMyw1Mi40eiIvPgo8cGF0aCBkPSJNODguNiw1NC43Yy0wLjUtMS42LTEuOS0yLjYtMy42LTIuOWMtMC45LTAuMS0xLjgsMC0yLjksMC4yYy0xLjksMC40LTMuNCwwLjYtNC40LDAuNmMzLjktNi43LDcuMS0xNC4zLDktMjEuNQoJYzMtMTEuNiwxLjQtMTYuOS0wLjUtMTkuM0M4MS4yLDUuNSw3NCwyLjEsNjUuMywyYy00LjctMC4xLTguOCwwLjgtMTAuOSwxLjVjLTEuOS0wLjQtNC4xLTAuNi02LjMtMC42QzQzLjksMi44LDQwLjIsMy43LDM3LDUuNgoJYy0xLjctMC42LTQuNi0xLjUtNy44LTJjLTcuNi0xLjMtMTMuOC0wLjMtMTguMywyLjljLTUuNCwzLjktOCwxMC42LTcuNSwxOS45YzAuMSwzLDEuOCwxMiw0LjQsMjAuNmMxLjUsNSwzLjEsOSw0LjYsMTIKCWMyLjQsNC40LDQuOSw3LjEsNy43LDhjMS42LDAuNSw0LjUsMC45LDcuNS0xLjZjMC40LDAuNSwwLjksMSwxLjYsMS40YzAuOSwwLjYsMS45LDEsMywxLjNjMy44LDEsNy40LDAuNywxMC40LTAuNlY2OQoJYzAuMSwwLjcsMC4xLDEuNCwwLjEsMi4xYzAuMiw0LjUsMC41LDgsMS40LDEwLjRjMC4xLDAuMiwwLjEsMC40LDAuMiwwLjZjMC40LDEuNCwxLjIsMy43LDMuMSw1LjVjMiwxLjgsNC40LDIuNCw2LjYsMi40CgljMS4xLDAsMi4yLTAuMSwzLjEtMC4zYzMuMy0wLjcsNy0xLjgsOS43LTUuNmMyLjUtMy42LDMuOC05LjEsNC0xNy43YzAtMC4yLDAuMS0wLjUsMC4xLTAuN2MwLjEtMC4yLDAuMS0wLjMsMC4xLTAuNWgwLjkKCWMzLjMsMC4yLDcuNC0wLjUsOS45LTEuN0M4My43LDYyLjYsOTAuMSw1OS4yLDg4LjYsNTQuN3ogTTgwLjQsNjEuMmMtMS44LDAuOS01LDEuNS03LjgsMS41Yy0xLjMsMC0yLjYtMC4yLTMuNS0wLjQKCWMtMC41LDQuMS0xLjQsMTEuOC0yLDE1LjFjLTEsNi0zLjcsOC44LTkuOSwxMC4xYy0xLDAuMS0xLjksMC4yLTIuOCwwLjJjLTUuOSwwLTcuOC00LjctOC42LTYuNmMtMC45LTIuMy0xLjMtMTAtMS4yLTE3LjkKCWMtMi4xLDEuOS00LjgsMy03LjksM2MtMS4zLDAtMi42LTAuMi0zLjktMC41Yy0wLjQtMC4xLTMuOC0xLTMuOC0zLjJjMC0yLDIuOS0yLjYsNC0yLjhjMy44LTAuOCw0LTEuMSw1LjItMi42CgljMC4yLTAuMywwLjUtMC43LDAuOS0xLjFjMCwwLDAsMCwwLTAuMWMtMS43LTAuMS0zLjQtMC41LTQuOS0xLjNjLTEuMSwxLjEtMy44LDQuMS02LjcsNy42Yy0xLjgsMi4yLTMuNiwyLjgtNSwyLjgKCWMtMC42LDAtMS4xLTAuMS0xLjUtMC4zYy0zLjgtMS4zLTcuNS03LjUtMTAuOS0xOC41Yy0yLjYtOC40LTQuMi0xNy4xLTQuMy0yMGMtMC40LTguNCwxLjgtMTQuNCw2LjUtMTcuOGM0LTIuOCw5LjUtMy43LDE2LjUtMi41CgljMy45LDAuNiw3LDEuNyw4LjQsMi4yYzIuOS0xLjksNi40LTIuOSwxMC41LTIuOGMyLjMsMCw0LjQsMC40LDYuMywwLjljMCwwLDAsMCwwLjEtMC4xYzAuNS0wLjMsNS4zLTEuOSwxMS4xLTEuOAoJYzgsMC4xLDE0LjUsMy4yLDE5LDguOWMxLjEsMS40LDEuNiwzLjcsMS42LDYuOWMwLDIuOS0wLjYsNi40LTEuNiwxMC4yYy0yLDguMS02LDE2LjctMTAuNywyMy45YzAuOCwwLjUsMywxLjMsOC44LDAuMQoJYzItMC40LDMuMiwwLDMuNiwxLjFDODYuNiw1Ny42LDgyLjYsNjAuMiw4MC40LDYxLjJ6Ii8+CjxnPgoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTMuMywxMy45Ii8+CjwvZz4KPC9zdmc+Cg==",
        is_external: false,
        is_multi_node_available: true,
        multi_node_description: "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over. ",
        prices: [
            {
                priceMultiplier: 3.0,
                resourceType: "CPU",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "RAM",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "main",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "block",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "snapshot",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "backup",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "OBJECT_STORAGE",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "LICENSE",
                serviceNameInUptime: "windows",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "UNASSIGNED_FLOATING_IP",
            },
            {
                price_multiplier: 3.0,
                resource_type: "CPU",
            },
            {
                price_multiplier: 3.0,
                resource_type: "RAM",
            },
            {
                price_multiplier: 3.0,
                resource_type: "BLOCK_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_SNAPSHOT",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_BACKUP",
            },
            {
                price_multiplier: 0.0,
                resource_type: "OBJECT_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "WINDOWS_LICENSE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "UNASSIGNED_FLOATING_IP",
            },
        ],
        read_more_url: "https://www.postgresql.org/docs/13/index.html",
        service_name: "postgresql",
        updated_at: "2021-11-18 16:08:58",
        uuid: "64c6886e-6e14-4021-ad43-b613039bfd0e",
        versions: ["13.4", "14.0"],
    },
    {
        created_at: "2021-10-14 11:20:49",
        description: "Fully managed database so you can focus on your code.",
        display_name: "MariaDB",
        icon: "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",
        is_external: false,
        is_multi_node_available: false,
        prices: [
            {
                priceMultiplier: 3.0,
                resourceType: "CPU",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "RAM",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "main",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "block",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "snapshot",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "backup",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "OBJECT_STORAGE",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "LICENSE",
                serviceNameInUptime: "windows",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "UNASSIGNED_FLOATING_IP",
            },
            {
                price_multiplier: 3.0,
                resource_type: "CPU",
            },
            {
                price_multiplier: 3.0,
                resource_type: "RAM",
            },
            {
                price_multiplier: 3.0,
                resource_type: "BLOCK_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_SNAPSHOT",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_BACKUP",
            },
            {
                price_multiplier: 0.0,
                resource_type: "OBJECT_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "WINDOWS_LICENSE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "UNASSIGNED_FLOATING_IP",
            },
        ],
        read_more_url: "https://bitnami.com/stack/mariadb",
        service_name: "mariadb",
        updated_at: "2021-10-20 12:32:27",
        uuid: "4e60723a-01b7-4db5-a6a6-7b57ba0da35b",
        versions: ["10.5", "10.5_1"],
    },
    {
        created_at: "2022-10-19 10:43:07",
        description: "Fully managed Kubernetes",
        display_name: "Kubernetes",
        icon: "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",
        is_external: true,
        is_multi_node_available: false,
        prices: [
            {
                priceMultiplier: 3.0,
                resourceType: "CPU",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "RAM",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "main",
            },
            {
                priceMultiplier: 3.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "block",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "snapshot",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "STORAGE",
                serviceNameInUptime: "backup",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "OBJECT_STORAGE",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "LICENSE",
                serviceNameInUptime: "windows",
            },
            {
                priceMultiplier: 0.0,
                resourceType: "UNASSIGNED_FLOATING_IP",
            },
            {
                price_multiplier: 3.0,
                resource_type: "CPU",
            },
            {
                price_multiplier: 3.0,
                resource_type: "RAM",
            },
            {
                price_multiplier: 3.0,
                resource_type: "BLOCK_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_SNAPSHOT",
            },
            {
                price_multiplier: 0.0,
                resource_type: "BLOCK_STORAGE_BACKUP",
            },
            {
                price_multiplier: 0.0,
                resource_type: "OBJECT_STORAGE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "WINDOWS_LICENSE",
            },
            {
                price_multiplier: 0.0,
                resource_type: "UNASSIGNED_FLOATING_IP",
            },
        ],
        read_more_url: "https://duckduckgo.com/?q=kubernetes",
        service_name: "kubernetes",
        specification: {
            provider: {
                workers: {
                    packages: [
                        {
                            cpu: 2,
                            ram: 2,
                            ssd: 40,
                            default: ["other"],
                            os: ["other"],
                        },
                        {
                            cpu: 4,
                            ram: 8,
                            ssd: 80,
                            default: [],
                            os: ["other"],
                        },
                        {
                            cpu: 6,
                            ram: 12,
                            ssd: 80,
                            default: [],
                            os: ["other"],
                        },
                        {
                            cpu: 8,
                            ram: 16,
                            ssd: 120,
                            default: [],
                            os: ["other"],
                        },
                    ],
                },
            },
        },
        updated_at: "2022-10-19 10:43:07",
        uuid: "1dc7f7cf-538f-4512-aa56-7313c5b90b8c",
        versions: ["1.26.13"],
    },
];
